import {ReadAsType} from '../incase-domain/common/fileReaderString';

export function randomString(radix: number): string {
    return (Math.random() + 1).toString(radix).substring(4);
}

export function getUploadFileReader(files: File[] | null, readAs: ReadAsType): null | {reader: FileReader; file: File}[] {
    if (!files) return null;

    const readersAndFiles: {reader: FileReader; file: File}[] | null = [];

    files.forEach((file) => {
        const reader = new FileReader();
        readAs === 'dataurl' && reader.readAsDataURL(file);
        readAs === 'text' && reader.readAsText(file);
        readersAndFiles.push({reader, file});
    });

    return readersAndFiles;
}

export const asymptoticScale = (input: number, min: number, max: number, rate = 1): number =>
    min + (max - min) * (1 - Math.exp(-rate * input));
